import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The equipment-vendor portal lives at /vendor. It is a separate chunk, so the
// marketing pages don't download the portal code.
const VendorApp = React.lazy(() => import('./vendor/VendorApp'));
const isVendorPortal = /^\/vendor(\/|$)/.test(window.location.pathname);

/** If the portal chunk can't load (stale tab after a deploy, network), offer a reload instead of a blank page. */
class PortalBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'Inter, system-ui, sans-serif', padding: 16, textAlign: 'center' }}>
        <div>
          <p style={{ margin: '0 0 14px', color: '#26302E' }}>The vendor portal could not load.</p>
          <button type="button" onClick={() => window.location.reload()} style={{ height: 42, padding: '0 18px', borderRadius: 12, border: 0, background: '#0B0F0E', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>Reload</button>
        </div>
      </div>
    );
  }
}

window.addEventListener('beforeinstallprompt', (e) => e.preventDefault());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isVendorPortal ? (
      <PortalBoundary>
        <React.Suspense fallback={null}>
          <VendorApp />
        </React.Suspense>
      </PortalBoundary>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
